<template>
  <div class="zadi-page-wrapper">
    <zadi-header />
    <slot />
    <the-footer />
    <search-box />
  </div>
</template>

<script>
import ZadiHeader from './ZadiHeader.vue'
import TheFooter from '@/app/shared/components/TheFooter.vue'
import SearchBox from '@/app/website/website-components/global-search/components/search-box.vue';

export default {
  name: 'ZadiLayout',
  components: {
    SearchBox,
    ZadiHeader,
    TheFooter
  },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap");

.zadi-page-wrapper {
  font-family: "Tajawal", sans-serif;
}
</style>